import {chain}    from "@Common/utils/fs";
import {keepOnly} from "@Common/utils/objects";

import {addVector} from "../../../common/add-vector";

export const rectToLines = (rect) => [
    {
        start: keepOnly(rect, ["x","y"]),
        rotation: 0,
        width: rect.width,
    },
    {
        start: chain(
            keepOnly(rect, ["x", "y"]),
            (_) => addVector(_, {x: rect.width, y:0}),
        ),
        rotation: 90,
        width: rect.height,
    },
    {
        start: chain(
            keepOnly(rect, ["x", "y"]),
            (_) => addVector(_, {x: rect.width, y: rect.height}),
        ),
        rotation: 180,
        width: rect.width,
    },
    {
        start: chain(
            keepOnly(rect, ["x", "y"]),
            (_) => addVector(_, {x: 0, y: rect.height}),
        ),
        rotation: 270,
        width: rect.height,
    },
];
